import React, { useEffect, useState } from "react";
import ClientApiKeysManager from "../../components/ApiKeys/ClientApiKeysManager";
import { getClients } from "../../services/clients";

/**
 * Admin-console API keys: pick a client, then manage that client's keys. The admin API requires
 * an explicit client id, which the manager scopes by.
 */
export const ApiKeys = () => {
  const [clients, setClients] = useState([]);

  useEffect(() => {
    let cancelled = false;

    getClients()
      .then((result) => {
        if (cancelled) return;
        const list = Array.isArray(result) ? result : result?.clients ?? [];
        setClients(Array.isArray(list) ? list : []);
      })
      .catch(() => {
        // The manager still works without names; the raw ids are shown instead.
        if (!cancelled) setClients([]);
      });

    return () => {
      cancelled = true;
    };
  }, []);

  return <ClientApiKeysManager scope="admin" clients={clients} />;
};

export default ApiKeys;
